module.exports = __webpack_public_path__ + "images/emoji/bikini.8d52e922caaa2a90a3b2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bikini.png
// module id = G5Ns
// module chunks = 1